export default "__VITE_ASSET__BzCCHVD9__"